import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b1df265&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1df265')) {
      api.createRecord('4b1df265', component.options)
    } else {
      api.reload('4b1df265', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b1df265&", function () {
      api.rerender('4b1df265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/index.vue"
export default component.exports